import { IeLynxObject } from "../../common/models/eLynxObject";
import { IAttachment } from "../../common/models/IAttachment";
import { RouteFromObjectType } from "../../common/utilities/RouteFromObjectType";
import restService from "../rest-service/RestService";
import { IObjectAttachmentsModel } from "./Models";

const AttachmentsDataService = {
    getAttachments: async function (
        groupID: number,
        eLynxObject: IeLynxObject,
        signal?: AbortSignal
    ): Promise<IObjectAttachmentsModel> {
        const path = `/groups/${groupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/attachments`

        const response = await restService.get<IObjectAttachmentsModel>(path, signal);

        return response.data;
    },
    saveAttachment: async function (
        groupID: number,
        eLynxObject: IeLynxObject,
        attachment: IAttachment,
        signal?: AbortSignal
    ): Promise<IAttachment | undefined> {
        const path = `/groups/${groupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/attachments`

        const response = await restService.post<IAttachment, IAttachment>(path, attachment, signal);

        return response.data;
    },
    deleteAttachment: async function (
        groupID: number,
        eLynxObject: IeLynxObject,
        attachment: IAttachment,
        signal?: AbortSignal
    ): Promise<void> {
        const path = `/groups/${groupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/attachments/${attachment.id}`

        await restService.delete<number>(path, signal);
    },
    getDownloadUrl: async function (
        groupID: number,
        eLynxObject: IeLynxObject,
        attachment: IAttachment,
        signal?: AbortSignal
    ): Promise<string> {
        const path = `/groups/${groupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/attachments/download?fileName=${attachment.fileName}`

        const response = await restService.get<string>(path, signal);

        return response.data;
    }
}

export default AttachmentsDataService;